export const APP_NAME = 'Direct Affinity CX'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'